import { render, staticRenderFns } from "./WishList_Desktop.vue?vue&type=template&id=9ebf985c&"
import script from "./WishList_Desktop.vue?vue&type=script&lang=js&"
export * from "./WishList_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./WishList_Desktop.vue?vue&type=style&index=0&id=9ebf985c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports